import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild, ElementRef  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesService } from '../../../services/roles.service';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { ModalComponent } from "../../modal/modal.component";

@Component({
  selector: 'app-roles-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ModalComponent],
  templateUrl: './roles-form.component.html',
  styleUrl: './roles-form.component.css'
})
export class RolesFormComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() editRole?: any;
  @Input() editMode?: boolean;
  @Input() user?: any;
  @Input() nombre?: any;
  @Input() status?: boolean;
  @Output() vuelve = new EventEmitter<any>();

  private fb = inject(FormBuilder);
  formulario: FormGroup;
  errorMessage!: string;
  rol =  inject(RolesService);
  menuList: any = []
  checkBoxList: CheckBox[] = []

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;

  suiche: boolean = true;

  constructor(){
    this.formulario = this.fb.group({
      nombre: new FormControl('', [Validators.required]),
      nombre_detalle: new FormControl('', [Validators.required]),
      descripcion: new FormControl('', [Validators.required])
    });
  }

  ngOnInit(): void {
    console.log('bueeeno: ',this.nombre)
    console.log('oooooo: ',this.user)
    console.log('aaaaa: ',this.editRole)
    console.log('eeeee: ',this.editMode)
    this.listMenus();
    this.fillPermisos(this.editRole.id_menu)
    if(this.editMode){
      this.formulario.patchValue({
        nombre: this.editRole.nombre,
        nombre_detalle: this.editRole.nombre_detalle,
        descripcion: this.editRole.descripcion
      })
    }
  }
  /*
  ngDoCheck(): void {
    this.fillPermisos(this.editRole.id_menu)
  }

  ngAfterContentInit(): void {
    this.fillPermisos(this.editRole.id_menu)
  }
  */
  ngAfterViewChecked(): void{
    if(this.suiche)this.fillPermisos(this.editRole.id_menu)
  }

  listMenus(){
    this.rol.listarMenu().subscribe({
      next: (rs) => {
        //this.rolesList = rs.data;
        this.menuList = rs.data;
        if(this.menuList != null){
          for (let index = 0; index < this.menuList.length; index++) {
            let tieneHijos:boolean = false
            this.menuList.forEach((v:any) => {
              if(this.menuList != null){
                if(v.menu_padre == this.menuList[index].id_menu.toString()){
                  tieneHijos = true
                }
              }
            });
            this.checkBoxList.push({
              checked: false,
              id: this.menuList[index].id_menu.toString()
            })
          }
        }

      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }



  checkPadre(id:string){
    const checkbox = document.getElementById(id) as HTMLInputElement
    //this.togglePermiso(id)
    this.menuList?.forEach((element:any) => {
      if(element.menu_padre == id){
        //console.log('esto es:  ',element.menu_padre)
        //this.togglePermiso(element.id_menu.toString())
        const checkboxHijo = document.getElementById(element.id_menu.toString()) as HTMLInputElement
        (checkbox.checked == true)? checkboxHijo.checked = true : checkboxHijo.checked = false;
        this.menuList?.forEach((hijo:any) => {
          if(hijo.menu_padre == element.id_menu.toString()){
            const checkboxNieto = document.getElementById(hijo.id_menu.toString()) as HTMLInputElement
            (checkbox.checked == true)? checkboxNieto.checked = true : checkboxNieto.checked = false;
          }
        })
      }
    })
  }

  checkHijo(id:string, idPadre: string){
    let valida: boolean = false
    const checkboxPadre = document.getElementById(idPadre) as HTMLInputElement
    for (let i = 0; i < this.menuList.length; i++) {
      let element = this.menuList[i];
      if(element.menu_padre == idPadre){
        let chk = document.getElementById(element.id_menu.toString()) as HTMLInputElement
        valida = true;
        this.menuList?.forEach((hijo:any) => {
          if(hijo.menu_padre == element.id_menu.toString()){
            const checkboxNieto = document.getElementById(hijo.id_menu.toString()) as HTMLInputElement
            (chk.checked == true)? checkboxNieto.checked = true : checkboxNieto.checked = false;
          }
        })
      }
    }
    (valida) ? checkboxPadre.checked = true : checkboxPadre.checked = false;

  }

  checkNieto(id:string, idPadre: string, idAbuelo: string){
    let valida_abuelo: boolean = false
    let valida_padre: boolean = false
    const checkboxAbuelo = document.getElementById(idAbuelo) as HTMLInputElement
    const checkboxPadre = document.getElementById(idPadre) as HTMLInputElement
    for (let i = 0; i < this.menuList.length; i++) {
      let element = this.menuList[i];
      if(element.menu_padre == idAbuelo){
        let chk = document.getElementById(element.id_menu.toString()) as HTMLInputElement
        valida_abuelo = true;
      }
      if(element.menu_padre == idPadre){
        valida_padre = true;
      }
    }
    (valida_abuelo) ? checkboxAbuelo.checked = true : checkboxAbuelo.checked = false;
    (valida_padre) ? checkboxPadre.checked = true : checkboxPadre.checked = false;
  }

  togglePermiso(id:string){
    this.checkBoxList.forEach(element => {
      if(element.id == id){
        console.log('asd:  ',element.id);
        (element.checked == true)? element.checked = false :element.checked = true;
      }
    });
  }

  fillPermisos(data:any){
    if(data){
      console.log('data:  ',data[0])

      data[0].forEach((element:any) => {
        this.checkBoxList.forEach(checkbox => {
          if(parseInt(checkbox.id) == element.id_menu){
            checkbox.checked = true;
            const elm = document.getElementById(checkbox.id) as HTMLInputElement
            console.log('quiero:  ',element.id_menu, '  el otro id: ', parseInt(checkbox.id), '  checkBox: ',checkbox.checked, '   prueba: ',elm)
            this.suiche = false;
            if (elm != null) elm.checked = true
          }
        })
      });
    }
  }

  cargar(){
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    const valoresSeleccionados: any = [];

    checkboxes.forEach((checkbox: any) => {
      if (checkbox.checked) valoresSeleccionados.push(parseInt(checkbox.value));
    });

    console.log('Valores seleccionados:', valoresSeleccionados);
    // Aquí puedes hacer lo que necesites con los valores seleccionados

    if(valoresSeleccionados.length > 0){
      if(this.formulario.valid){
        Object.assign(this.formulario.value, {
          'usuario_sesion': this.user.id_institucional,
          'id_rol': this.editRole.id_rol,
          'estatus': this.status,
          'menus': valoresSeleccionados
        });
        console.log('Valores a enviar: ', this.formulario.value);
        this.mdl.cargando();
        if(this.editMode){
          this.rol.actualizaRol(this.formulario.value).subscribe({
            next: (rs) => {
              this.mdl.cerrar();
              this.vuelve.emit({value: false, validador: false});
            },
            error: (error) => {
              this.errorMessage = error.message; // Muestra el mensaje de error al usuario
              //console.error("Error en el componente:", error); // Registro del error en el componente
            }
          });
        }
        else{
          this.rol.insertarRol(this.formulario.value).subscribe({
            next: (rs) => {
              this.mdl.cerrar();
              this.vuelve.emit({value: false, validador: false});
            },
            error: (error) => {
              this.errorMessage = error.message; // Muestra el mensaje de error al usuario
              //console.error("Error en el componente:", error); // Registro del error en el componente
            }
          });
        }

      }
      else{
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = 'Debe llenar los campos de descripción del rol.';
        this.mdl.alerta();
      }
    }
    else{
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Debe selecionar al menos un item.';
      this.mdl.alerta();
    }

  }

  volver(){
    this.vuelve.emit({value: false, validador: true});
  }

}

class CheckBox {
  checked: boolean = false;
  id: string = ''
}
